/*
  cookie
*/
/**
 * Cookies logic
 */

/************************************************
	Cookie Banner (WL & CB)
*************************************************/
if (!isCashbackSite()) {
  $(document.body).on("click", ".desk_cookie_banner #submit, .mob_cookie_banner form .icon, .mob_cookie_banner .submit", function() {
    $.ajax({
        type: "POST",
        url: "/Site/SetCookieConsent",
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        success: function() {
        },
        error: function() {
        }
    });
  });
}
else {
  $(document.body).on("click", ".desk_cookie_banner #submit, .mob_cookie_banner form .icon, .mob_cookie_banner .submit", function() {
    Cookies.set("cobk", "1");
  });
}


/************************************************
	Cookie Banner (CLOSING)
*************************************************/
$(document.body).on("click", ".desk_cookie_banner .close-trigger, .mob_cookie_banner .close-trigger", function() {
  $(".desk_cookie_banner").remove();
  $(".mob_cookie_banner").remove();
});

/************************************************
	Cookie Banner Hide
*************************************************/
if (Cookies.get("cobk")) {
  $(".desk_cookie_banner, .mob_cookie_banner").hide();
}
